import { useIntl } from 'react-intl';
import { Button } from 'antd';

import { CheckOutlined } from '@ant-design/icons';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import InfiniteTable, { ColumnsType } from '@/components/_common/InfiniteTable';

import { useSuppliersReduce } from '@/core/domain/people/Suppliers/Suppliers.hooks';
import { SupplierReduced } from '@/core/domain/people/Suppliers/Suppliers.types';
import { COLUMNS_WIDTH } from '@/utils/table';

interface Props {
  handleSelect: (name: string, id: number) => void;
}

function SuppliersList({ handleSelect }: Props) {
  const intl = useIntl().formatMessage;
  const { data, isFetching, hasNextPage, fetchNextPage } = useSuppliersReduce();
  const listagem = flatInfiniteData(data);
  const columns: ColumnsType<SupplierReduced> = [
    {
      title: 'CPF/CNPJ',
      dataIndex: 'cnpj',
      key: 'cnpj',
      width: COLUMNS_WIDTH.document,
      ellipsis: true,
      render: (_, row) => {
        if (row.cpf) return row.cpf;
        if (row.cnpj) return row.cnpj;
        return '-';
      },
    },
    {
      title: intl({
        id: 'layout.menu.fiscal.invoice.referenced.list.name',
      }),
      dataIndex: 'name',
      key: 'name',
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      dataIndex: 'actions',
      align: 'center',
      width: COLUMNS_WIDTH.small,
      fixed: 'right',
      render: (_, row) => (
        <Button
          type="primary"
          onClick={() => handleSelect(row.name, row.id)}
          icon={<CheckOutlined />}
        />
      ),
    },
  ];
  return (
    <InfiniteTable
      fetchNextPage={fetchNextPage}
      columns={columns}
      hasNextPage={hasNextPage}
      loading={isFetching}
      dataSource={listagem}
      rowKey={(row) => row.id}
    />
  );
}

export default SuppliersList;
